import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import AchieveImageContent from './AchieveImageContent/AchieveImageContent';
import BeyondImageContent from './BeyondImageContent/BeyondImageContent';
import TurnbullImageContent from './TurnbullImageContent/TurnbullImageContent';
import FiveLakesImageContent from './FiveLakesImageContent/FiveLakesImageContent';
import styles from './index.module.scss';

export type PartnerHeroProps = SliceComponentProps<Content.PartnerHeroSlice>;

const PartnerHero = ({ slice }: PartnerHeroProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${styles.wrapper} ${styles[slice.variation]}`}
    >
      <div className={styles.container}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>
            <PrismicRichText field={slice.primary.title} />
          </div>
          <p className={styles.subtitle}>{slice.primary.subtitle}</p>
        </div>
        {slice.variation === 'default' && (
          <div className={styles.achieveWrapper}>
            <AchieveImageContent data={slice.primary} />
          </div>
        )}
        {slice.variation === 'beyond' && (
          <div className={styles.beyondWrapper}>
            <BeyondImageContent data={slice.primary} />
          </div>
        )}
        {slice.variation === 'turnbull' && (
          <div className={styles.turnbullWrapper}>
            <TurnbullImageContent data={slice.primary} />
          </div>
        )}
        {slice.variation === 'fiveLakes' && (
          <div className={styles.fiveLakesWrapper}>
            <FiveLakesImageContent data={slice.primary} />
          </div>
        )}
      </div>
    </section>
  );
};

export default PartnerHero;
